import type { ComponentProps } from 'react'
import IdentityPreview from '../../shared/IdentityPreview'

type Props = ComponentProps<typeof IdentityPreview>

export default function Step6_IdentityPreview(props: Props) {
  return <IdentityPreview {...props} />
}

